var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSlashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8921 9.44922L1.67517 0.328125C1.54387 0.210938 1.35629 0.25 1.24375 0.367188L1.05618 0.621094C0.962388 0.757812 0.981146 0.953125 1.11245 1.05078L12.3294 10.1914C12.4419 10.2891 12.6482 10.2695 12.742 10.1328L12.9296 9.89844C13.0421 9.76172 13.0046 9.56641 12.8921 9.44922ZM7.00227 1.1875C7.97765 1.1875 8.80298 2.04688 8.80298 3.0625C8.80298 3.62891 8.55913 4.11719 8.20274 4.44922L8.91552 5.03516C9.40322 4.52734 9.70333 3.84375 9.70333 3.0625C9.70333 1.51953 8.4841 0.25 7.00227 0.25C6.02688 0.25 5.1828 0.796875 4.69511 1.59766L5.40789 2.18359C5.72677 1.59766 6.30825 1.1875 7.00227 1.1875ZM3.70097 9.3125V8.82422C3.70097 7.88672 4.41375 7.125 5.3141 7.125C5.38913 7.125 5.48292 7.16406 5.61422 7.20312C6.0644 7.35938 6.53333 7.4375 7.00227 7.4375C7.15233 7.4375 7.28363 7.41797 7.43369 7.39844L6.1957 6.40234C6.10191 6.36328 6.00813 6.34375 5.91434 6.32422C5.72677 6.24609 5.52044 6.20703 5.3141 6.20703C3.92606 6.1875 2.80061 7.37891 2.80061 8.82422V9.3125C2.80061 9.83984 3.19452 10.25 3.70097 10.25H10.3036C10.4724 10.25 10.6224 10.2109 10.7725 10.1133L9.79712 9.3125H3.70097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSlashWhite);
export default __webpack_public_path__ + "static/media/user-slash-white.b021a1d3.svg";
export { ForwardRef as ReactComponent };